import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    paymentDetails: string;
    requiredFields: string;
    summary: string;
    upgradePlan: string;
    loadingLabel: string;
    dialogCloseLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Header title for payment details step */
            paymentDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConversionDialog.paymentDetails?c=1mhs59xzj2oeh", defaultMessage: "Payment Details" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle text for payment step indicating required fields */
            requiredFields: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConversionDialog.requiredFields?c=y8ej754acc9v", defaultMessage: "All fields are required unless marked optional." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Header title for summary step */
            summary: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConversionDialog.summary?c=1uv6yqyw6ghkf", defaultMessage: "Summary" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Header title for upgrade plan step */
            upgradePlan: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConversionDialog.upgradePlan?c=12wd4y25wwyx6", defaultMessage: "Upgrade Plan" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Loading label for content */
            loadingLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConversionDialog.loadingLabel?c=2z6x46esp49fs", defaultMessage: "Loading content..." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for dialog close button */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConversionDialog.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
